import toastr from '../toastr/toastr.min.js';
import $ from "jquery";

class ToastService {
    constructor() {
    }

    messageTimer = null;

    toast(message, title, type) {
        let cssClass = type == "info" || type == "success" ? "toastr-bottom-right" : "toastr-top-right";
        toastr[type](message, title, { timeout: 6000, positionClass: cssClass, preventDuplicates: true });
    }

    info(message, title) {
        this.toast(message, title, "info");
    }

    success(message, title) {
        this.toast(message, title, "success");
    }

    error(message, title) {
        this.toast(message, title, "error");
    }

    warning(message, title) {
        this.toast(message, title, "warning");
    }

    status(message) {
        if (this.messageTimer) {
            clearTimeout(this.messageTimer);
            this.messageTimer = null;
        }

        let elem = $("#status");
        let styleClass = "message-footer";

        if (!elem[0].classList.contains(styleClass)) {
            elem[0].classList.add(styleClass);
        }

        elem.html(message);
        this.messageTimer = setTimeout(() => 
        { 
            elem.empty();
            elem[0].classList.remove(styleClass);
        }, 5000);
    }
}

const toastService = new ToastService();

export { toastService }




// WEBPACK FOOTER //
// ./src/framework/utils/toast-service.js